import { Component, OnInit , Input } from '@angular/core';

import { UserService, SidebarWrapperService } from '@services/index';

@Component({
  selector: 'aff-mini-profile',
  templateUrl: './mini-profile.component.html',
  styleUrls: ['./mini-profile.component.scss']
})
export class MiniProfileComponent implements OnInit {
  @Input() profile: any = {};
  showDropDown: boolean = false;

  constructor(private userService: UserService, private sidebarWrapperService: SidebarWrapperService) { }

  ngOnInit() {
  }

  onShowDropDown(e: any): void {
    e.stopPropagation();
    this.showDropDown = !this.showDropDown;
  }

  openProfile(){
    this.sidebarWrapperService.openSidebar({showTabs: true, activeTab: 1})
  }

  logout(): void {
    this.userService.logout();
  }

}
